import * as React from "react";

const SvgTrapezoid2 = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="200"
    fill="none"
    viewBox="0 0 344 200"
  >
    <path
      fill="#D7EAFF"
      d="M332.533 85.151 9.009 12.725v177.097h323.524z"
    ></path>
    <path
      fill={rackColor}
      fillRule="evenodd"
      d="M344 77.01 0 0v200h344zM10.238 189.822h323.524V85.152L10.238 12.724z"
      clipRule="evenodd"
    ></path>
    <path
      d="M344 77.01 0 0v200h344zM10.238  "
      fill="none"
      stroke="black"
      strokeWidth="0.8"
    />
  </svg>
);

export default SvgTrapezoid2;
